import { Button } from "primereact/button";

const ButtonAccordionHeader = ({ onClick, disabled }) => (
    <>
        <div>
            <span>Добавить налог/платеж</span>
            <Button
                type="button"
                label="Добавить"
                icon="pi pi-plus"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClick();
                }}
                disabled={disabled}
            />
        </div>
    </>
);

export default ButtonAccordionHeader;